import { render, staticRenderFns } from "./SsoAuthorize.vue?vue&type=template&id=78373be8&scoped=true&"
import script from "./SsoAuthorize.vue?vue&type=script&lang=js&"
export * from "./SsoAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./SsoAuthorize.vue?vue&type=style&index=0&id=78373be8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78373be8",
  null
  
)

export default component.exports